import { IButton } from 'common/builder/buttons/buttonInterfaces'
import { isUrlButton as getIsUrlButton } from 'common/builder/buttons/buttonTypeHelpers'
import { getButtonAppearance } from 'common/builder/components/chart/FlowChart/adapters/generic/buttons/converterRules/utils/getButtonAppearance'
import { getButtonIcon } from 'common/builder/components/chart/FlowChart/adapters/generic/buttons/converterRules/utils/getButtonIcon'
import { getIsMessageTemplateUrlButton } from 'common/builder/components/chart/FlowChart/adapters/generic/buttons/converterRules/utils/getIsMessageTemplateUrlButton'
import { FlowChartButtonBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonBuilder'
import { FlowChartButtonStatsBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonStatsBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import {
  ButtonConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { ButtonType } from 'common/builder/constants/ButtonType'
import EntityType from 'common/builder/constants/EntityType'

const NoNextStepButtonTypes = [ButtonType.CALL, ButtonType.ANSWER, ButtonType.SHARE]
const NoStatButtonTypes = [ButtonType.CALL, ButtonType.SHARE]

export const CommonButtonGenericConverterRule: ConverterRule<
  IButton,
  FlowChartButton,
  ButtonConverterRulePayload
> = {
  predicate: (entity: IButton) => entity?.entity === EntityType.BUTTON,

  convert: (entity, { state, builderId, fields }): FlowChartButton | null => {
    /** Collect button attributes */

    const isUrlButton = getIsUrlButton(entity)
    const isMessageTemplateUrlButton = getIsMessageTemplateUrlButton(entity, builderId, state)
    const hasNoStats = NoStatButtonTypes.includes(entity.type) || isMessageTemplateUrlButton
    const hasNoNextStep = NoNextStepButtonTypes.includes(entity.type) || isMessageTemplateUrlButton
    const icon = getButtonIcon(entity)
    const appearance = getButtonAppearance(entity, builderId, state)

    /** Build button  */

    const buttonBuilder = new FlowChartButtonBuilder(entity.id)
      .withCaption(replaceFieldsInString(entity.caption, fields))
      .withAppearance(appearance)
      .withIsFallback('isFallback' in entity && Boolean(entity.isFallback))
      .withIsInteractive(true)
      .withIcon(icon || null)

    if (!hasNoNextStep) {
      buttonBuilder.withNextStep(
        new FlowChartNextStepBuilder(entity.id)
          .withColor(
            isUrlButton
              ? sharedStyles.Colors.ACTIONS_CONNECTOR
              : sharedStyles.Colors.Tints.NEUTRAL[2],
          )
          .build(),
      )
    }

    if (!hasNoStats) {
      const { users = 0, clicks = 0, segmentId = null } = entity?.stats || {}

      buttonBuilder.withStats(
        new FlowChartButtonStatsBuilder()
          .withUsers(users)
          .withClicks(clicks)
          .withSegmentId(segmentId)
          .build(),
      )
    }

    return buttonBuilder.build()
  },
}
